import React, { createContext, PropsWithChildren, useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

export enum AnalyticsTab {
  Insights = "insights",
  Reports = "reports"
}

type InitPageProps = {
  tab: AnalyticsTab;
};

type AnalyticsContext = {
  activeTab: AnalyticsTab;
  changeTab: (value: AnalyticsTab) => void;
};

type AnalyticsContextProviderProps = {
  initPageData?: InitPageProps;
};

const AnalyticsContext = createContext({} as AnalyticsContext);

export const AnalyticsContextProvider = ({
  children,
  initPageData
}: PropsWithChildren<AnalyticsContextProviderProps>) => {
  const [activeTab, setActiveTab] = useState<AnalyticsTab>(AnalyticsTab.Insights);
  const history = useHistory();

  useEffect(() => {
    if (initPageData) {
      setActiveTab(initPageData.tab);
    }
  }, []);

  return (
    <AnalyticsContext.Provider
      value={{
        activeTab,
        changeTab: (value) => {
          setActiveTab(value);
          history.push(`/analytics/${value}`);
        }
      }}
    >
      {children}
    </AnalyticsContext.Provider>
  );
};

export const useAnalyticsContext = () => useContext(AnalyticsContext);
